import Reg from "../components/regPerformance/Reg";
import "../components/regPerformance/reg-performance.scss";
import { useState, useEffect } from "react";
import useAxios from "../services/useAxios";
import { translateToReactSelect } from "../utils/helperFunction";
import TableCard from "../components/tableCard/TableCard";
import { TimeStampToJalali, swalFunc } from "../utils/helperFunction";
import CustomButton from "../components/kits/button/CustomButton";
import Loader from "../utils/Loader";
import ToastCustomize from "../components/kits/ToastCustomize";
export default function RegPerformance() {
  const { loading, execute: baseData } = useAxios("test/get_operation");
  const { loadingCancel, execute: cancellationApi } = useAxios(
    "api/Update_operation"
  );
  const [personnelList, setPersonnelList] = useState([]);
  const [servicesList, setServicesList] = useState([]);
  const [operationList, setOperationList] = useState([]);
  const [validate, setValidate] = useState(-1);
  const [updater, setUpdater] = useState(false);
  const [header, setHeader] = useState([
    {
      type: "title",
      title: "شماره",
      name: "operation__id",
    },
    {
      type: "title",
      title: "بازه",
      name: "period",
    },
    {
      type: "title",
      title: "نام پرسنل",
      name: "personnel",
    },
    {
      type: "title",
      title: "نام ارزیاب",
      name: "appraiser_name",
    },
    {
      type: "title",
      title: "نوع خدمت",
      name: "service",
    },
    {
      type: "title",
      title: "حجم",
      name: "number",
    },
    {
      type: "title",
      title: "تاریخ ثبت",
      name: "submitMtm",
    },
    {
      type: "title",
      title: "عملیات",
      name: "operation",
    },
  ]);
  const [content, setContent] = useState([]);
  const operation = (id) => {
    return (
      <CustomButton
        color="danger"
        size="base"
        style={{ width: 80 }}
        className="m-auto text-center justify-content-center shadow-none"
        state="normal"
        circle={false}
        onClick={(e) => {
          swalFunc(
            `آیا از ابطال عملکرد مطمئن هستید؟`,
            () => cancellation(id),
            "warning"
          );
        }}
      >
        ابطال
      </CustomButton>
    );
  };
  const cancellation = (id) => {
    cancellationApi({ conditions: `id/=/${id}`, keyvalues: `status,-1` }).then(
      (result) => {
        if (result.status == 1) {
          ToastCustomize({
            mainText: "ابطال با موفقیت انجام شد.",
            duration: 3000,
            toastType: "success",
            color: "success",
            position: "top-center",
            hasHeader: false,
          });
          setUpdater((prev) => !prev);
        } else {
          ToastCustomize({
            mainText: "متاسفانه مشکلی در ابطال به وجود آمده است..",
            duration: 3000,
            toastType: "error",
            color: "danger",
            position: "top-center",
            hasHeader: false,
          });
        }
      }
    );
  };
  useEffect(() => {
    if (validate == 0) {
      ToastCustomize({
        mainText: "در حال حاضر امکان ثبت عملکرد وجود ندارد.",
        duration: 3000,
        toastType: "error",
        color: "danger",
        position: "top-center",
        hasHeader: false,
      });
    }
  }, [validate]);
  useEffect(() => {
    baseData().then((data) => {
      setOperationList(data.operations);
      setPersonnelList(
        translateToReactSelect(false, data.personels, "fullname", "id")
      );
      setServicesList(
        translateToReactSelect(false, data.services, "title", "id")
      );
      setValidate(data.verification);
    });
  }, [updater]);
  useEffect(() => {
    setContent(operationList);
  }, [operationList]);
  return loading ? (
    <Loader />
  ) : (
    <div className="m-3 border rounded rounded-4 reg-performance ">
      <Reg
        personnelList={personnelList}
        servicesList={servicesList}
        setUpdater={setUpdater}
        validate={validate}
      />
      <div className="my-4">
        {content.length > 0
          ? content.reverse().map((value) => {
              let submitHour = parseInt(value?.hour);
              let periodTemp = 0;

              if (submitHour >= 8 && submitHour <= 12) periodTemp = "8-12";
              else if (submitHour > 12 && submitHour <= 17)
                periodTemp = "12-17";
              return (
                <TableCard
                  column={header}
                  content={{
                    ...value,
                    personnel: personnelList.filter(
                      (val) => val.value == value.personnel_id
                    )[0]?.label,
                    service: servicesList.filter(
                      (val) => val.value == value.service_id
                    )[0]?.label,
                    submitMtm: (
                      <div>
                        <div>
                          {TimeStampToJalali(parseInt(value.mtm) * 1000)}
                        </div>
                        <div
                          className="mt-1"
                          style={{ fontWeight: "lighter", fontSize: 12 }}
                        >
                          (
                          {TimeStampToJalali(
                            parseInt(value.mtm) * 1000,
                            "HH:mm"
                          )}
                          )
                        </div>
                      </div>
                    ),
                    period: periodTemp,
                    operation:
                      value.status != -1
                        ? operation(value.operation__id)
                        : "--", //-1 is cancel performance
                    appraiser_name:
                      value.fname == "" || value.lname == ""
                        ? "--"
                        : `${value.fname} ${value.lname}`,
                  }}
                  bg={value.status != -1 ? "navy_custom" : "dark_light_custom"}
                  widthParent={"95%"}
                  showSelect="false"
                ></TableCard>
              );
            })
          : "در حال حاضر عملکردی ثبت نشده است."}
      </div>
    </div>
  );
}
